import { createSurveyStyles } from '@sm/webassets';
import { Theme } from '~app/sharedTypes';

const useStyles = createSurveyStyles((surveyTheme: Theme) => ({
  anchorElement: {
    fontSize: 12,
    lineHeight: '18px',
    textDecoration: 'underline',
    display: 'block',
    textAlign: 'center',
    margin: '0 auto',
    color: surveyTheme.questionColor,
    fontFamily: 'National2,"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
}));

export default useStyles;
